import { createElement } from 'react';
const GrtDiv = function GrtDiv(props) {
    return (<>
            {props.isSlot ? <div {...props}>{props.children}</div> : <div {...props}>{props.value}</div>}

        </>);
};
export default GrtDiv;
